import { connect } from 'react-redux';
import { compose } from 'recompose';
import { translator } from './withTranslationProvider';

const mapStateToProps = state => ({ lang: state.langCode, defaultLang: state.defaultLangCode, translatedMessages: state.translations });
const mapDispatchToProps = dispatch => ({ setTranslations: translation => dispatch({ type: 'SET_TRANSLATION', payload: translation }) });

const translateRedux = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translator
);

export default translateRedux;

export const localeMinimalRedux = compose(connect(state => ({
  lang: state.langCode,
  defaultLang: state.defaultLangCode
})));


// WEBPACK FOOTER //
// ./src/Common/Translations/translateRedux.js